import { ENV } from '@/constants';
import { toast } from 'sonner';

export const notify = (message: string, type: 'success' | 'info' | 'error' = 'success') => {

	if (!message) {
		return;
	}

	if (type === 'success') {
		toast.success(message);
	}
	else if (type === 'info') {
		toast.info(message);
	} else {
		toast.error(message ?? 'Une erreur s\'est produite', { duration: 5000 });
	}

};

export const notifyInternalMessage = (error: any): undefined => {
	ENV.name === 'development' &&
		console.error(error);

	notify(error?.internalMessage, 'error');
};
